import type { CategoryResourceListResponseApi } from '@ingenico/api-sdk-configuration-public';
import type { SmartFieldCategory } from '../../models/smartFields.model';
import { toIsoStringIfDate } from '../utils/date.utils';

export function mapGetCategoriesResponse(response: CategoryResourceListResponseApi): SmartFieldCategory[] {
  return response.data.map(({ id, name, updateDate, updatedBy, creationDate, createdBy }) => ({
    id,
    name,
    updateDate: toIsoStringIfDate(updateDate),
    updatedBy,
    creationDate: toIsoStringIfDate(creationDate),
    createdBy,
  }));
}
